module.exports = __webpack_public_path__ + "img/fancy_charles2.5fc5b5d3.jpg";